import {
  addObj,
  getAll,
  getPage,
  getDetail,
  modifyObj,
  deleteObj
} from '@/api/replacedeviceorderserv'

export default {
  state: {
    state_ReplaceDeviceOrder_AddObjResult: null,
    state_ReplaceDeviceOrder_GetAllResult: null,
    state_ReplaceDeviceOrder_GetPageResult: null,
    state_ReplaceDeviceOrder_GetDetailResult: null,
    state_ReplaceDeviceOrder_ModifyObjResult: null,
    state_ReplaceDeviceOrder_DeleteObjResult: null
  },
  mutations: {
    SET_REPLACEDEVICEORDER_ADDOBJ_RESULT: (state, rst) => {
      state.state_ReplaceDeviceOrder_AddObjResult = rst
    },
    SET_REPLACEDEVICEORDER_GETALL_RESULT: (state, rst) => {
      state.state_ReplaceDeviceOrder_GetAllResult = rst
    },
    SET_REPLACEDEVICEORDER_GETPAGE_RESULT: (state, rst) => {
      state.state_ReplaceDeviceOrder_GetPageResult = rst
    },
    SET_REPLACEDEVICEORDER_GETDETAIL_RESULT: (state, rst) => {
      state.state_ReplaceDeviceOrder_GetDetailResult = rst
    },
    SET_REPLACEDEVICEORDER_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_ReplaceDeviceOrder_ModifyObjResult = rst
    },
    SET_REPLACEDEVICEORDER_DELETEOBJ_RESULT: (state, rst) => {
      state.state_ReplaceDeviceOrder_DeleteObjResult = rst
    }
  },
  actions: {
    ReplaceDeviceOrderServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_REPLACEDEVICEORDER_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_REPLACEDEVICEORDER_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    ReplaceDeviceOrderServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_REPLACEDEVICEORDER_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_REPLACEDEVICEORDER_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    ReplaceDeviceOrderServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_REPLACEDEVICEORDER_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_REPLACEDEVICEORDER_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    ReplaceDeviceOrderServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_REPLACEDEVICEORDER_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_REPLACEDEVICEORDER_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    ReplaceDeviceOrderServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_REPLACEDEVICEORDER_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_REPLACEDEVICEORDER_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    ReplaceDeviceOrderServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_REPLACEDEVICEORDER_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_REPLACEDEVICEORDER_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_ReplaceDeviceOrder_AddObjResult: state => {
      return state.state_ReplaceDeviceOrder_AddObjResult
    },
    get_ReplaceDeviceOrder_GetAllResult: state => {
      return state.state_ReplaceDeviceOrder_GetAllResult
    },
    get_ReplaceDeviceOrder_GetPageResult: state => {
      return state.state_ReplaceDeviceOrder_GetPageResult
    },
    get_ReplaceDeviceOrder_GetDetailResult: state => {
      return state.state_ReplaceDeviceOrder_GetDetailResult
    },
    get_ReplaceDeviceOrder_ModifyObjResult: state => {
      return state.state_ReplaceDeviceOrder_ModifyObjResult
    },
    get_ReplaceDeviceOrder_DeleteObjResult: state => {
      return state.state_ReplaceDeviceOrder_DeleteObjResult
    }
  }
}
